/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-19 18:16:59
 * @LastEditTime: 2022-01-21 22:29:10
 * @LastEditors: zhao - 🍉
 * @Description: 客户列表
 * @FilePath: /zhzj-admin/src/page/CustomerServices/CustomerList/index.jsx
 */
import { Divider } from 'antd'
import React, { useEffect, useState, useRef } from 'react'
import AuthButton from '../../../components/AuthButton/AuthButton'
import PageWrap from '../../../components/PageWrap'
import TableHelper from '../../../components/TableHelper'
import { fetchWechatServicesCustomerList, fetchWechatServicesSalesAllList } from '../../../services/wechatServices'
import { params2Object } from '../../../utils'
import ChatList from './components/ChatListModal'
import DisplayTagModal from './components/DisplayTagModal'
import ReplaceSales from './components/ReplaceSalesModal'
import UpdateCustomer from './components/UpdateCustomerModal'

const CustomerList = (props) => {
    
    const [salesList, setSalesList] = useState([]);
    let ReplaceSalesRef = null
    let UpdateCustomerRef = null
    let ChatListRef = useRef()
    let TableHelperRef = useRef()
    let DisplayTagModalRef = useRef()

    const handleReplaceSales = (record) => {
        ReplaceSalesRef.open(record).then(() => {
            TableHelperRef.current.postDataSource()
        })
    }
    const handleUpdateNickName = (record) => {
        UpdateCustomerRef.open(record).then(() => {
            TableHelperRef.current.postDataSource()
        })
    }
    const handleChatList = (record) => {
        ChatListRef.current.open(record)
    }
    const handleDisplayTag = (record) => {
        DisplayTagModalRef.current.open(record)
    }
    const columns = [
        { title: '客户昵称', dataIndex: 'buyer_nickname', },
        { title: '客户openId', dataIndex: 'openid', },
        { title: '小区楼栋', dataIndex: 'buildingName', },
        { title: '客户姓名', dataIndex: 'customerName', },
        { title: '客户手机号码', dataIndex: 'customerPhone', },
        { title: '房号', dataIndex: 'roomNo', },
        { title: '项目名称', dataIndex: 'projectName', },
        { title: '商户简称', dataIndex: 'shortName', },
        { title: '操作', dataIndex: 'actions', width: 250, render: (text, record) => {
            return (
                <React.Fragment>
                    <AuthButton authkey="n-2-1">
                        <a onClick={() => handleReplaceSales(record)}>更换顾问</a>
                        <Divider type="vertical" />
                    </AuthButton>
                    <AuthButton authkey="n-2-2">
                        <a onClick={() => handleUpdateNickName(record)}>修改昵称</a>
                        <Divider type="vertical" />
                    </AuthButton>
                    <AuthButton authkey="n-2-3">
                        <a onClick={() => handleDisplayTag(record)}>修改自定义参数</a>
                        <Divider type="vertical" />
                    </AuthButton>
                    <AuthButton authkey="n-2-4">
                        <a onClick={() => handleChatList(record)}>聊天记录</a>
                    </AuthButton>
                </React.Fragment>
            )
        } }
    ]
    const getUrlGuideAccount = () => {
        return params2Object(props.location.search).guideAccount
    }
    const searchOptions = getUrlGuideAccount() ? 
        false : 
        [{ key: 'guideAccount', type: 'select', options: salesList }]

 

    const postSalesList = () => {
        fetchWechatServicesSalesAllList().then(res => {
            if(res){
                setSalesList(res.map(e => ({ value: e.guide_account, title: e.guide_nickname })))
            }
        })
    }

    const parseRequestData = (data) => {
        if (getUrlGuideAccount()) {
            data.guideAccount = getUrlGuideAccount()
        }
        return data
    }

    useEffect(() => {
        postSalesList()
    }, []);
    return (
        <PageWrap>
         
            <TableHelper 
                parseRequestData={parseRequestData} 
                request={fetchWechatServicesCustomerList} 
                getRef={ref => TableHelperRef.current = ref}
                columns={columns} 
                searchOptions={searchOptions} 
            />
            <ReplaceSales salesList={salesList} getRef={ref => ReplaceSalesRef = ref } />
            <UpdateCustomer getRef={ref => UpdateCustomerRef = ref } />
            <ChatList ref={ChatListRef} />
            <DisplayTagModal ref={DisplayTagModalRef} />
        </PageWrap>
    )
}

export default CustomerList


// WEBPACK FOOTER //
// ./src/page/CustomerServices/CustomerList/index.jsx